import { AlignTypes } from '@monorepo-web/components-library';
import { helperFormat, FormatTypes } from '@monorepo-web/utils';
export function formatCardsData(resumo, preferenceCustomizacao, moneyPrefix, isMobile = false) {
    var _a, _b;
    const saldo1 = {
        title: `${(_a = preferenceCustomizacao === null || preferenceCustomizacao === void 0 ? void 0 : preferenceCustomizacao.ResCart_textoCard1) !== null && _a !== void 0 ? _a : 'Saldo'} ${resumo === null || resumo === void 0 ? void 0 : resumo.datas.data_ini.split('-').reverse().join('/')}`,
        value: helperFormat(resumo === null || resumo === void 0 ? void 0 : resumo.saldoIni, FormatTypes.monetary, 2, moneyPrefix),
    };
    const movim = {
        title: 'Movimentações',
        value: helperFormat(resumo === null || resumo === void 0 ? void 0 : resumo.movimentacoes, FormatTypes.monetary, 2, moneyPrefix),
    };
    const impostosPagos = {
        title: 'Impostos Pagos',
        value: helperFormat(resumo === null || resumo === void 0 ? void 0 : resumo.impostospagos, FormatTypes.monetary, 2, moneyPrefix),
    };
    const rendimentoBruto = {
        title: 'Rendimento Bruto',
        value: helperFormat(resumo === null || resumo === void 0 ? void 0 : resumo.rendimentoBruto, FormatTypes.monetary, 2, moneyPrefix),
    };
    const saldo2 = {
        title: `${(_b = preferenceCustomizacao === null || preferenceCustomizacao === void 0 ? void 0 : preferenceCustomizacao.ResCart_textoCard5) !== null && _b !== void 0 ? _b : 'Saldo'} ${resumo === null || resumo === void 0 ? void 0 : resumo.datas.data_fim.split('-').reverse().join('/')}`,
        value: helperFormat(resumo === null || resumo === void 0 ? void 0 : resumo.saldoFim, FormatTypes.monetary, 2, moneyPrefix),
    };
    if (isMobile) {
        return [saldo1, saldo2, movim, impostosPagos, rendimentoBruto];
    }
    else {
        return [saldo1, movim, impostosPagos, rendimentoBruto, saldo2];
    }
}
export function formatRowsRetorno(retorno, preferenceCustomizacao, moneyPrefix) {
    const rowsRetorno = retorno
        ? retorno.map((ret) => {
            var _a;
            let formatType = FormatTypes.percentage;
            let isBold = false;
            if (ret.descricao === 'Rend. Nominal')
                formatType = FormatTypes.monetary;
            if (((_a = preferenceCustomizacao === null || preferenceCustomizacao === void 0 ? void 0 : preferenceCustomizacao.ResCart_boldRetornoNomial) !== null && _a !== void 0 ? _a : false) &&
                (ret.descricao === 'Rend. Nominal' || ret.descricao === 'Var. Nominal')) {
                isBold = true;
            }
            return {
                ativo: ret.descricao,
                mes: helperFormat(ret.mes, formatType, 2, moneyPrefix),
                ano: helperFormat(ret.ano, formatType, 2, moneyPrefix),
                mes12: helperFormat(ret.m12, formatType, 2, moneyPrefix),
                mes24: helperFormat(ret.m24, formatType, 2, moneyPrefix),
                periodo: helperFormat(ret.periodo, formatType, 2, moneyPrefix),
                bold: isBold,
            };
        })
        : null;
    return rowsRetorno;
}
export function formatRowsClasse(rendPorClasse, dadosPercentResumo, isPercentToggle, preferenceCustomizacao, moneyPrefix) {
    const rowsClasse = rendPorClasse
        ? rendPorClasse.map((classe, ind) => {
            var _a, _b, _c, _d, _e;
            const colorIndex = classe.classe !== 'Caixa Bloqueado' &&
                classe.classe !== 'Total da Carteira' &&
                classe.classe !== 'Total Disponível' &&
                classe.classe !== 'Total'
                ? ind
                : false;
            const row = {
                classe: classe.classe,
                saldo: helperFormat(classe.saldo, FormatTypes.monetary, 2, moneyPrefix),
                percent: helperFormat(Number(classe.percent) * 100, FormatTypes.percentage, 2),
                mes: isPercentToggle
                    ? helperFormat((_a = dadosPercentResumo === null || dadosPercentResumo === void 0 ? void 0 : dadosPercentResumo[ind]) === null || _a === void 0 ? void 0 : _a.mes_perf, FormatTypes.percentage, 2, moneyPrefix)
                    : helperFormat(classe.mes, FormatTypes.monetary, 2, moneyPrefix),
                ano: isPercentToggle
                    ? helperFormat((_b = dadosPercentResumo === null || dadosPercentResumo === void 0 ? void 0 : dadosPercentResumo[ind]) === null || _b === void 0 ? void 0 : _b.ano_perf, FormatTypes.percentage, 2, moneyPrefix)
                    : helperFormat(classe.ano, FormatTypes.monetary, 2, moneyPrefix),
                colorIndex,
                bold: classe.classe === 'Total Disponível' ||
                    classe.classe === 'Total da Carteira' ||
                    classe.classe === 'Total da Carteira' ||
                    classe.classe === 'Total',
            };
            if ((_c = preferenceCustomizacao === null || preferenceCustomizacao === void 0 ? void 0 : preferenceCustomizacao.ResCart_percent) !== null && _c !== void 0 ? _c : false) {
                row.mesPerf = helperFormat((_d = dadosPercentResumo === null || dadosPercentResumo === void 0 ? void 0 : dadosPercentResumo[ind]) === null || _d === void 0 ? void 0 : _d.mes_perf, FormatTypes.percentage, 2);
                row.anoPerf = helperFormat((_e = dadosPercentResumo === null || dadosPercentResumo === void 0 ? void 0 : dadosPercentResumo[ind]) === null || _e === void 0 ? void 0 : _e.ano_perf, FormatTypes.percentage, 2);
            }
            return row;
        })
        : null;
    return rowsClasse;
}
export function formatRowsMovim(movimentacoes, moneyPrefix) {
    const rowsMovim = movimentacoes
        ? movimentacoes.map((movim) => {
            return {
                mesano: movim.data,
                saldoMovim: helperFormat(movim.saldoMovim, FormatTypes.monetary, 2, moneyPrefix),
                saldoBruto: helperFormat(movim.saldoBruto, FormatTypes.monetary, 2, moneyPrefix),
            };
        })
        : [];
    return rowsMovim;
}
export function formatRowsLiq(tabela_liquidez) {
    const rowsLiq = tabela_liquidez
        ? tabela_liquidez.slice(1).map((arrayLiq) => {
            return {
                periodo: arrayLiq[0],
                valor: helperFormat(arrayLiq[1], FormatTypes.decimals),
                percent: helperFormat(Number(arrayLiq[2]) * 100, FormatTypes.decimals),
            };
        })
        : null;
    return rowsLiq;
}
export function formatRowsTabelaPorClasse(alocClasse, ativoModal, moneyPrefix, theme) {
    const rowsTabelaPorClasse = [];
    alocClasse === null || alocClasse === void 0 ? void 0 : alocClasse.filter((e) => (e.classe && e.classe === ativoModal) ||
        (e.classe === '' && ativoModal.toLowerCase() === 'outros')).forEach((classe) => {
        let sbr_total = 0;
        classe.ativos.forEach((atv) => {
            sbr_total += atv.sbr_fim;
            rowsTabelaPorClasse.push({
                ativo: atv.nome_ativo,
                aloc: helperFormat(atv.alocacao * 100, FormatTypes.percentage),
                sbr: helperFormat(atv.sbr_fim, FormatTypes.monetary, 2, moneyPrefix),
            });
        });
        rowsTabelaPorClasse.unshift({
            ativo: ativoModal,
            aloc: helperFormat(classe.alocacao * 100, FormatTypes.percentage),
            sbr: helperFormat(sbr_total, FormatTypes.monetary, 2, moneyPrefix),
            bgColor: '#E7E7E7',
            color: theme.fontColor,
            bold: true,
        });
    });
    return rowsTabelaPorClasse;
}
export function formatRowsTabelaPorCustodiante(alocCustodiante, ativoModal, moneyPrefix, theme) {
    const rowsTabelaPorCustodiante = [];
    alocCustodiante === null || alocCustodiante === void 0 ? void 0 : alocCustodiante.filter((e) => (e.custodiante && e.custodiante === ativoModal) ||
        (e.custodiante === '' && ativoModal.toLowerCase() === 'outros')).forEach((custodiante) => {
        let sbr_total = 0;
        custodiante.ativos.forEach((atv) => {
            sbr_total += atv.sbr_fim;
            rowsTabelaPorCustodiante.push({
                ativo: atv.nome_ativo,
                aloc: helperFormat(atv.alocacao * 100, FormatTypes.percentage),
                sbr: helperFormat(atv.sbr_fim, FormatTypes.monetary, 2, moneyPrefix),
            });
        });
        rowsTabelaPorCustodiante.unshift({
            ativo: ativoModal,
            aloc: helperFormat(custodiante.alocacao * 100, FormatTypes.percentage),
            sbr: helperFormat(sbr_total, FormatTypes.monetary, 2, moneyPrefix),
            bgColor: '#E7E7E7',
            color: theme.fontColor,
            bold: true,
        });
    });
    return rowsTabelaPorCustodiante;
}
export function formatPieChartClasse(rendPorClasse, theme) {
    const pieChartClassData = rendPorClasse
        ? rendPorClasse
            .filter((obj) => obj.classe !== 'Caixa Bloqueado' &&
            obj.classe !== 'Total da Carteira' &&
            obj.classe !== 'Total Disponível' &&
            obj.classe !== 'Total')
            .map((obj, index) => ({
            name: obj.classe,
            value: typeof obj.percent === 'number'
                ? Number((obj.percent * 100).toFixed(2))
                : Number((Number(obj.percent) * 100).toFixed(2)),
            color: theme.chartColors[index % theme.chartColors.length],
        }))
            .sort((a, b) => (a.value > b.value ? -1 : b.value > a.value ? 1 : 0))
        : null;
    return pieChartClassData;
}
export function formatPieChartCustodiante(alocCustodiante, preferenceCustomizacao) {
    let pieChartCustodianteData = null;
    if (alocCustodiante) {
        pieChartCustodianteData = alocCustodiante
            .map((custodiante) => {
            var _a;
            // valor em porcentagem
            let value = typeof custodiante.alocacao === 'number'
                ? Number((custodiante.alocacao * 100).toFixed(2))
                : Number((Number(custodiante.alocacao) * 100).toFixed(2));
            if ((_a = preferenceCustomizacao === null || preferenceCustomizacao === void 0 ? void 0 : preferenceCustomizacao.ResCart_graficoAlocacaoVolume) !== null && _a !== void 0 ? _a : false) {
                // calcula o volume custodiante (Soma do Saldo bruto de todos os ativos do Custodiante)
                value = custodiante.ativos.reduce((total, atv) => total + atv.sbr_fim, 0);
            }
            return {
                name: custodiante.custodiante || 'Outros',
                value: value,
            };
        })
            .sort((a, b) => (a.value > b.value ? -1 : b.value > a.value ? 1 : 0));
    }
    return pieChartCustodianteData;
}
export function getColumnsLiq() {
    const columnsLiq = [
        {
            id: 'periodo',
            label: 'Tempo de Resgate (DC)',
        },
        {
            id: 'valor',
            label: 'Valor Líquido',
            align: AlignTypes.right,
        },
        {
            id: 'percent',
            label: '%',
            align: AlignTypes.right,
        },
    ];
    return columnsLiq;
}
export function getColumnsRetorno(periodo) {
    const columnsRetorno = [
        {
            id: 'ativo',
            label: 'Ativo',
            freeze: true,
        },
        {
            id: 'mes',
            label: 'Mês',
            align: AlignTypes.right,
        },
        {
            id: 'ano',
            label: 'Ano',
            align: AlignTypes.right,
        },
        {
            id: 'mes12',
            label: '12 meses',
            align: AlignTypes.right,
        },
        {
            id: 'mes24',
            label: '24 meses',
            align: AlignTypes.right,
        },
    ];
    if (periodo !== '12m' && periodo !== '24m' && periodo !== 'mes_atual') {
        columnsRetorno.push({
            id: 'periodo',
            label: periodo === 'maximo' ? 'Desde o início' : 'Período',
            align: AlignTypes.right,
        });
    }
    return columnsRetorno;
}
export function getColumnsClasse(preferenceCustomizacao, moneyPrefix) {
    var _a;
    let columnsClasse = [];
    if ((_a = preferenceCustomizacao === null || preferenceCustomizacao === void 0 ? void 0 : preferenceCustomizacao.ResCart_percent) !== null && _a !== void 0 ? _a : false) {
        columnsClasse = [
            {
                id: 'classe',
                label: 'Classe',
                orderBy: 'classe',
                colorLegend: true,
                freeze: true,
            },
            {
                id: 'percent',
                label: '%',
                align: AlignTypes.right,
            },
            {
                id: 'saldo',
                label: 'Saldo Bruto',
                align: AlignTypes.right,
            },
            {
                id: 'mes',
                label: `No Mês (${moneyPrefix})`,
                align: AlignTypes.right,
            },
            {
                id: 'ano',
                label: `No Ano (${moneyPrefix})`,
                align: AlignTypes.right,
            },
            {
                id: 'mesPerf',
                label: 'No Mês (%)',
                align: AlignTypes.right,
            },
            {
                id: 'anoPerf',
                label: 'No Ano (%)',
                align: AlignTypes.right,
            },
        ];
    }
    else {
        columnsClasse = [
            {
                id: 'classe',
                label: 'Classe',
                orderBy: 'classe',
                colorLegend: true,
                freeze: true,
            },
            {
                id: 'saldo',
                label: 'Saldo Bruto',
                align: AlignTypes.right,
            },
            {
                id: 'percent',
                label: '%',
                align: AlignTypes.right,
            },
            {
                id: 'mes',
                label: 'No Mês',
                align: AlignTypes.right,
            },
            {
                id: 'ano',
                label: 'No Ano',
                align: AlignTypes.right,
            },
        ];
    }
    return columnsClasse;
}
export function getColumnsMovim() {
    const columnsMovim = [
        {
            id: 'mesano',
            label: 'Mês/Ano',
        },
        {
            id: 'saldoMovim',
            label: 'Saldo Movimentações',
            align: AlignTypes.right,
        },
        {
            id: 'saldoBruto',
            label: 'Saldo Bruto',
            align: AlignTypes.right,
        },
    ];
    return columnsMovim;
}
export function getColumnsModal() {
    const columnsModal = [
        {
            id: 'ativo',
            label: 'Ativo',
            width: '300px',
        },
        {
            id: 'aloc',
            label: 'Alocação',
            align: AlignTypes.right,
        },
        {
            id: 'sbr',
            label: 'Saldo Bruto',
            align: AlignTypes.right,
        },
    ];
    return columnsModal;
}
